import React from 'react'
import NotFound404 from '../components/404'
import ServicesHeader from '../components/ServiceBanner';
import ServiceCards from '../components/ServiceCards';
import ProcessFlow from '../components/ServiceSteps';
import ServiceComponent from '../components/ServiceDetail1';
import VisionSection from '../components/ServiceDetail2';
import ServiceConsult from '../components/ServiceConsult';
import Benefits from '../components/ServiceDetail3';

function Servicepage ()  {
  return (
    <div>
        <ServicesHeader />
        <ServiceCards />
        <ServiceComponent />
        <div style={{ marginTop: '60px' }}>
        <ProcessFlow />
      </div>
      <div style={{ marginTop: '50px' }}>
      <VisionSection />
      </div>
        
      <div style={{ marginTop: '50px' }}>
      <ServiceConsult />
      </div>
      <div style={{ marginTop: '10px' }}>
      <Benefits />
      </div>
     
      {/* <NotFound404 /> */}
    
    </div>
  )
}

export default Servicepage
